import ILabyData, { ILabyrinthe } from '../../interfaces/ILabyData';
import { IMatriceLaby, DirectionLitterale } from '../../interfaces/ILabyData';

interface positionRelative {
    left:number;
    top:number;
}
export const lignesMatrices = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
export function getRelativePosition(childContainer:HTMLElement|HTMLImageElement|null, parentContainer:HTMLElement|null):positionRelative{
    if (!childContainer || !parentContainer) return {left:0, top:0}
    const childBox = childContainer.getBoundingClientRect();
    const parentBox = parentContainer.getBoundingClientRect();
    let theLeft = childBox.left - parentBox.left;
    let theTop = childBox.top - parentBox.top;
    return {left:theLeft, top:theTop}
}

export function getLabyDataFromId(id:number, data:ILabyData|undefined):ILabyrinthe{
    if (data){
        return data.labyrinthes.filter((laby) =>(laby.id === id))[0];
    }
    return {} as ILabyrinthe;
}

export function getEmptyLabyMatrice():any{
    const matriceArray:any = {};
    matriceArray.ligneA = "0000000000000000";
    matriceArray.ligneB = "0000000000000000";
    matriceArray.ligneC = "0000000000000000";
    matriceArray.ligneD = "0000000000000000";
    matriceArray.ligneE = "0000000000000000";
    matriceArray.ligneF = "0000000000000000";
    matriceArray.ligneG = "0000000000000000";
    matriceArray.ligneH = "0000000000000000";
    matriceArray.ligneI = "0000000000000000";
    matriceArray.ligneJ = "0000000000000000";
    return matriceArray;
}

export function labyMatricToArray(matrice:IMatriceLaby):Array<String>{
    let matriceArray = [];
    for (var i=0; i<lignesMatrices.length; i++){
        const lineName = `ligne${lignesMatrices[i]}` as keyof IMatriceLaby;
        const curLineSplit = matrice[lineName].split("").splice(0);
        matriceArray.push(...curLineSplit);
    }
    return matriceArray;
}
export function logReadableMatrice(matrice:Array<String>){
    let output = "";
    for (var i=0; i<matrice.length; i++){
        if (i % 16 === 0) output += "\n";
        output += matrice[i];
    }
    console.log(output);
}

export interface objPosition {
    colonne:number;
    ligne:string;
}
export function getPositionFromIndex(index:number):objPosition{
    const column = (index % 16);
    const row = lignesMatrices[Math.floor(index / 16)];
    return {colonne:column, ligne:row};
}
export function getIndexFromObjPosition(pos:objPosition):number{
    const ligneAdd = lignesMatrices.indexOf(pos.ligne) * 16;
    const colAdd = pos.colonne;
    return (ligneAdd+colAdd);
}

export function obtenirCaseVoisine(objPos:objPosition, dir:DirectionLitterale):objPosition|null{
    // console.log("move perso case");
    let objRetour = null;
    const indexLigne = lignesMatrices.indexOf(objPos.ligne);
    switch(dir){
        case "GAUCHE":
            const newColonneG = (objPos.colonne - 1 > 0) ? objPos.colonne - 1 : 0;
            objRetour = {ligne:objPos.ligne, colonne:newColonneG};
        break;
        case "DROITE":
            const newColonneD = (objPos.colonne + 1 < 16) ? objPos.colonne + 1 : 15;
            objRetour = {ligne:objPos.ligne, colonne:newColonneD};
        break;
        case "HAUT":
            const newLigneH = (indexLigne - 1 > 0) ? lignesMatrices[indexLigne - 1] : lignesMatrices[0];
            objRetour = {ligne:newLigneH, colonne:objPos.colonne};
        break;
        case "BAS":
            const newLigneB = (indexLigne + 1 < 10) ? lignesMatrices[indexLigne + 1] : lignesMatrices[9];
            objRetour = {ligne:newLigneB, colonne:objPos.colonne};
        break;
    }
    return objRetour;
}

export function getDirectionsAllowed(curP:objPosition, matDeplacement:Array<string>):Array<DirectionLitterale>{
    let permises = ["GAUCHE", "DROITE", "HAUT", "BAS"] as DirectionLitterale[];
    const deplacementCode = matDeplacement[getIndexFromObjPosition(curP)];
    // console.log("Ma case avant de bouger etait: " + deplacementCode);
    switch(deplacementCode){
        case "1": case "2": case "3": case "5": case "6": case "9": case "E":
            permises.splice(permises.indexOf("GAUCHE"), 1);
        break;
    }
    switch(deplacementCode){
        case "1": case "3": case "4": case "7": case "8": case "B": case "E":
            permises.splice(permises.indexOf("DROITE"), 1);
        break;
    }
    switch(deplacementCode){
        case "2": case "3": case "4": case "6": case "7": case "A": case "D":
            permises.splice(permises.indexOf("HAUT"), 1);
        break;
    }
    switch(deplacementCode){
        case "1": case "2": case "4": case "5": case "8": case "C": case "D":
            permises.splice(permises.indexOf("BAS"), 1);
        break;
    }
    if (deplacementCode === "F"){
        // On est arrivé sur l'escalier.
        permises = [];
    }
    return permises;
}

export function trouverCoffreDomByCode2(containerCoffres:HTMLDivElement|null, codeToFind:String){
    const coffreDivContainer:HTMLDivElement|null = containerCoffres;
    if (coffreDivContainer){
      const lesCoffres = coffreDivContainer.children;
      for (var i=0; i<lesCoffres.length; i++){
        if (lesCoffres[i].getAttribute("data-code") === codeToFind){
          return lesCoffres[i];
        }
      }
    }
    return null;
}